<template>
    <footer>
        <p>With 💖 by <a href="https://github.com/BrandMV">BrandMV</a></p>
    </footer>
</template>
<script>
export default {
    name: "Footer"
    
}
</script>
<style scoped>
p{
    color: white;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
}
a{
    text-decoration: none;
    color: white;
}
footer{
    position: fixed;
    max-width: 100vw;
    width: 100%;
    background: #2c3e50;
    bottom: 0;
    padding: 1.5rem;
}
    
</style>